// Heuristics for auto-detecting column names in user-uploaded CSVs. Returns
// "" when nothing matches, mirroring the empty-string sentinel used by the
// column-mapping selects.

export function detectAddressColumn(headers: string[]): string {
  return (
    headers.find((h) =>
      /^(address_?1|line_?1|addr(?:ess)?_?line_?1|address)$/.test(
        h.toLowerCase()
      )
    ) || ""
  );
}

export function detectPostcodeColumn(headers: string[]): string {
  return (
    headers.find((h) =>
      /^(postcode|postal_?code|post_?code|zip)$/.test(h.toLowerCase())
    ) || ""
  );
}

export function detectUprnColumn(headers: string[]): string {
  return headers.find((h) => /^(uprn)$/.test(h.toLowerCase())) || "";
}
